import { Box } from '@factorialco/deprecated-design-system'
import { CostCentersListDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CostCenterEmployeeList } from 'modules/cost_centers/components/Resources/Employees/CostCenterEmployeeList'

const CostCentersPeoplePage = () => {
  const { loading, data } = useQuery(CostCentersListDocument, {
    fetchPolicy: 'no-cache',
  })

  const costCenters = data?.costCenters?.costCentersConnection?.edges.map((edge) => edge.node) ?? []

  if (loading)
    return (
      <Box alignItems="center" justifyContent="center" height="full" width="full" flexGrow>
        <Loading />
      </Box>
    )

  return <CostCenterEmployeeList costCenters={costCenters} />
}

export default CostCentersPeoplePage
